<template>
    <div class="row g-3" :class="{'inactive-stroke': employee.disabled_at || employee.deleted_at }">
        <div class="col-1">
            <div class="form-check">
                <input class="form-check-input"
                       type="checkbox"
                       :checked="bulk_selected.indexOf(employee.id) !== -1"
                       @change="toggleBulk()"
                       :disabled="employee.deleted_at"
                       >
            </div>
        </div>
        <div class="col-1">
            <span>{{ employee.id }}</span>
        </div>
        <div class="col-3">
            <span v-if="employee.deleted_at">
                 <i>Raderad</i>
             </span>
            <span v-else>{{ employee.name }}
                <span class="badge" style="text-decoration: none;" v-if="employee.disabled_at">Inaktivt</span>
                <span class="badge" style="text-decoration: none; background-color: #a51b1b;" v-if="employee.invalid_import">Felaktig eller dublett</span>
            </span>
        </div>
        <div class="col-3">
            <span>{{ employee.phone }}</span>
        </div>
        <div class="col-4">
            <span :class="{ 'break-all' : displayFrom == 'company' }" v-if="displayFrom == 'company'">{{ employee.workplace_title }}</span>
            <span :class="{ 'break-all' : displayFrom == 'employees' }" v-if="displayFrom == 'employees'">{{ employee.company_name }}</span>
        </div>
        <div class="col-3">
            <span v-if="!employee.deleted_at">
                {{ employee.status }}
            </span>
        </div>
        <div class="col-2">
            <span>{{ employee.created_at }}</span>
        </div>
        <div class="col-2">
            <span>{{ employee.last_treatment_at }}</span>
        </div>
        <div class="col-5 d-flex justify-content-end">

            <span v-if="employee.disabled_at">
                <button-disable-account btnClass="btn-sm" :employee="employee" @refresh="refresh()">
                    Återaktivera
                    <div class="tooltip-label">Återaktivera inloggningen</div>
                </button-disable-account>
            </span>
            <span v-if="!employee.disabled_at && !employee.deleted_at">
                <button class="btn btn-info btn-sm" :disabled="!employee.company_has_active_contract || !employee.activated_at" @click="openEmployeeModal(employee.id, 'employee-modal-punch')"><img
                    src="/images/admin/icon-register.svg">
                    <div class="tooltip-label">Registrera en behandling</div>
                </button>

                <button-app-url btnClass="btn-info btn-sm" :employee="employee">
                    <img src="/images/admin/icon-smartphone.svg">
                    <div class="tooltip-label">Skicka en notis med länk till webappen</div>
                </button-app-url>

                <button-restore-password btnClass="btn-info btn-sm" :employee="employee">
                    <img src="/images/admin/icon-renew.svg">
                    <div class="tooltip-label">Skicka återställningslänk för lösenord</div>
                </button-restore-password>

                <!-- <button-disable-account btnClass="btn-warning" :employee="employee" @success="refresh()">
                    <img src="/images/admin/icon-deactivate.svg">
                    <div class="tooltip-label">Inaktivera kontot tillfälligt</div>
                </button-disable-account> -->
                <button class="btn btn-primary btn-sm" @click="openEmployeeModal(employee.id)">Hantera
                    <div class="tooltip-label">Redigera och hantera den anställde</div>
                </button>
            </span>

        </div>
    </div>
</template>

<script>
import buttonAppUrl from './button-app-url'
import buttonRestorePassword from './button-restore-password'
import buttonDisableAccount from './button-disable-account'

export default {

    components: {
        buttonAppUrl,
        buttonRestorePassword,
        buttonDisableAccount
    },

    props: {
        employee: {
            required: true
        },
        bulk_selected: {
            required: true
        },
        displayFrom: {
            default: 'employees' // employees || company
        }
    },

    methods: {

        openEmployeeModal (employee_id, tab = null) {
            this.$emit('openEmployeeModal', employee_id, tab)
        },

        toggleBulk () {
            const bulk_selected = this.bulk_selected
            const index = bulk_selected.indexOf(this.employee.id)
            if (index !== -1) {
                bulk_selected.splice(index, 1)
            } else {
                bulk_selected.push(this.employee.id)
            }

            this.$emit('update:bulk_selected', bulk_selected)
        },

        refresh () {
            this.$emit('refresh')
        }
    }

}

</script>
